import { Dispatch, AnyAction } from 'redux';
import { CMDSpCarnivaltreasureStatistics, ICommand } from '../live';
import { hostsSliceActions } from '../../../modules/host/slice';
import { AbstractHandler } from './AbstractHandler';
import { CarnivalTreasureStatistics } from '@/models/games/carnivalTreasure';

export class CMDSpCarnivaltreasureStatisticsHandler extends AbstractHandler {
    _command: CMDSpCarnivaltreasureStatistics;

    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpCarnivaltreasureStatistics;
    }

    handle(dispatch: Dispatch<AnyAction>): void {
        const statistics = {} as CarnivalTreasureStatistics;
        const hostId = this._command.HostID;
        statistics.Main1Count = this._command.Statistics.Main1Count;
        statistics.Main2Count = this._command.Statistics.Main2Count;
        statistics.Main4Count = this._command.Statistics.Main4Count;
        statistics.Main7Count = this._command.Statistics.Main7Count;
        statistics.Main18Count = this._command.Statistics.Main18Count;
        statistics.Main40Count = this._command.Statistics.Main40Count;
        dispatch(hostsSliceActions.updateStatistic({ hostId, statistics }));
    }
}
